// CATALOG-DATA-132-R1 — same-origin static JSON fetch with SPA HTML rejection.
// Route-relative `/s2-105/data/*.json` returns index.html (200). Prefer `/data/…`
// and never abort the candidate loop on a single bad body.

export function catalogDataCandidateUrls(file: string): string[] {
  const urls: string[] = [`/data/${file}`];
  try {
    const path = window.location.pathname;
    const base = path.endsWith("/") ? path : path.replace(/[^/]*$/, "");
    if (base && base !== "/") urls.push(`${base}data/${file}`);
  } catch {
    /* ignore */
  }
  return [...new Set(urls)];
}

/**
 * Fetch optional same-origin JSON. Skips non-OK and HTML SPA fallbacks.
 * Uses cache-bust + no-store so stale empty/404 HTML cannot stick.
 */
export async function fetchSameOriginJsonFile<T extends object>(
  file: string,
  isValid: (json: unknown) => json is T,
): Promise<T | null> {
  for (const url of catalogDataCandidateUrls(file)) {
    try {
      const res = await fetch(`${url}?b=${Date.now()}`, {
        credentials: "same-origin",
        cache: "no-store",
        headers: { Accept: "application/json" },
      });
      if (!res.ok) continue;
      const text = await res.text();
      const trimmed = text.trimStart();
      if (!trimmed || trimmed.startsWith("<")) continue;
      const json: unknown = JSON.parse(trimmed);
      if (isValid(json)) return json;
    } catch {
      /* try next candidate */
    }
  }
  return null;
}
